import { useId, useEffect } from 'react';
import { useAttributePreference } from '../../common/util/preferences';
import { map } from '../core/MapView';
import useMapOverlays from './useMapOverlays';
import { useMapControlSetting } from '../controls/useMapControls';

const MapOverlay = () => {
  const id = useId();

  const mapOverlays = useMapOverlays();
  const selectedMapOverlay = useAttributePreference('selectedMapOverlay');

  // Map controls panel settings - usando hook individual para melhor performance
  const showTrafficSetting = useMapControlSetting('showTraffic', Boolean(selectedMapOverlay));
  const showTraffic = showTrafficSetting ?? Boolean(selectedMapOverlay);

  const activeOverlay = mapOverlays.filter((overlay) => overlay.available).find((overlay) => overlay.id === selectedMapOverlay);

  useEffect(() => {
    if (activeOverlay) {
      if (!map.getSource(id)) {
        map.addSource(id, activeOverlay.source);
      }
      if (!map.getLayer(id)) {
        map.addLayer({
          id,
          type: 'raster',
          source: id,
          layout: { visibility: 'visible' },
        });
      }
    }
    return () => {
      if (map.getLayer(id)) map.removeLayer(id);
      if (map.getSource(id)) map.removeSource(id);
    };
  }, [id, activeOverlay]);

  // Toggle traffic overlay visibility based on control panel settings
  useEffect(() => {
    if (!map || !activeOverlay) return;
    try {
      if (map.getLayer(id)) {
        map.setLayoutProperty(id, 'visibility', showTraffic ? 'visible' : 'none');
      }
    } catch {
      // Layer not yet created
    }
  }, [id, activeOverlay, showTraffic]);

  return null;
};

export default MapOverlay;
